import { ReactNode } from 'react';

import { useShouldSignInFromChainPage } from 'modules/chains/hooks/useShouldSignInFromChainPage';

import { RedirectToAuthPage } from './components/RedirectToAuthPage';

export interface ProductsPageGuardProps {
  children: ReactNode;
}

export const ProductsPageGuard = ({ children }: ProductsPageGuardProps) => {
  const shouldSignIn = useShouldSignInFromChainPage();

  if (shouldSignIn) {
    return <RedirectToAuthPage />;
  }

  return <>{children}</>;
};
